
// Light and Dark mode color palettes
const lightPalette = {
  colorPrimary: '#03aba5',
  colorBgBase: '#ffffff',
  colorTextBase: '#000',
};

const darkPalette = {
  colorPrimary: '#03aba5',
  colorBgBase: '#333',
  colorTextBase: '#ffffff'
};

export const getTheme = (mode) => {
  return mode === 'dark' ? darkPalette : lightPalette;
};

